
export enum ZoomFitEnum {
  // eslint-disable-next-line no-unused-vars
  ACTUAL,
  // eslint-disable-next-line no-unused-vars
  WIDTH,
  // eslint-disable-next-line no-unused-vars
  HEIGHT,
  // eslint-disable-next-line no-unused-vars
  FULL,

  FREE,
}

export enum PLAYSTATE {
  live,
  play,
  stop,
  pause,
  rewind,
  trackRewind,
  setAutoStop,
  unsetAutoStop,
}
